import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

const PageWrapper = forwardRef(({ children, className }, ref) => {
  return (
    <div ref={ref} className={classNames("pageWrapper", className)}>
      {children}
    </div>
  );
});

PageWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

PageWrapper.defaultProps = {
  className: null,
};

export default PageWrapper;
